// extracted by mini-css-extract-plugin
export default {"title":"title--LyKzj form-group__label","item":"item--Kdd10","footer":"footer--Q5ZUf"};